import React from 'react';
import { Badge } from '@opendate-app/setlist';
import { COMPETITOR_COLOR, RELATIONSHIPS, YOURS_COLOR } from './competitiveUtils';

const GRID = { display: 'grid', gridTemplateColumns: 'minmax(140px, 200px) minmax(0, 1fr) minmax(0, 1fr) 96px', gap: 12, alignItems: 'center' };
const small = { fontSize: 12, color: 'var(--sl-text-tertiary)' };

function CompetitiveHeadToHead({
  rows, level, yourName, competitorName, selectedKey, onSelect,
}) {
  const sorted = rows.slice().sort((a, b) => b.competitor - a.competitor || (b.yours + b.competitor) - (a.yours + a.competitor))
    .slice(0, level === 'agency' ? 16 : 24);
  const max = Math.max(1, ...sorted.map((row) => Math.max(row.yours, row.competitor)));

  return (
    <div>
      <div style={{ ...GRID, ...small, color: 'var(--sl-text-quaternary)', paddingBottom: 8, borderBottom: '1px solid var(--sl-border-secondary)' }}>
        <span>{level === 'agency' ? 'Agency' : 'Agent'}</span>
        <span style={{ textAlign: 'right' }}>{yourName}</span>
        <span>{competitorName}</span>
        <span>Relationship</span>
      </div>
      {sorted.map((row) => (
        <button
          type="button"
          key={row.key}
          onClick={() => onSelect(selectedKey === row.key ? null : row.key)}
          className="w-100 text-left"
          style={{
            ...GRID,
            padding: '7px 0',
            border: 0,
            borderBottom: '1px solid var(--sl-border-tertiary)',
            background: selectedKey === row.key ? 'var(--sl-bg-secondary)' : 'transparent',
            cursor: 'pointer',
          }}
        >
          <div style={{ minWidth: 0 }}>
            <div className="text-truncate" style={{ fontSize: 14, color: 'var(--sl-text-primary)' }}>{row.name}</div>
            <div className="text-truncate" style={{ ...small, color: 'var(--sl-text-quaternary)' }}>
              {level === 'agency' ? `${row.agent_count} ${row.agent_count === 1 ? 'agent' : 'agents'}` : (row.agency || 'Unknown agency')}
            </div>
          </div>
          <div className="d-flex justify-content-end align-items-center" style={{ gap: 8 }}>
            <span style={small}>{row.yours || ''}</span>
            <div style={{ height: 14, width: `${(row.yours / max) * 100}%`, background: YOURS_COLOR, borderRadius: '4px 0 0 4px' }} />
          </div>
          <div className="d-flex align-items-center" style={{ gap: 8, borderLeft: '1px solid var(--sl-border-primary)' }}>
            <div style={{ height: 14, width: `${(row.competitor / max) * 100}%`, background: COMPETITOR_COLOR, borderRadius: '0 4px 4px 0' }} />
            <span style={small}>{row.competitor || ''}</span>
          </div>
          <span><Badge size="sm" color={RELATIONSHIPS[row.relationship].color}>{RELATIONSHIPS[row.relationship].label}</Badge></span>
        </button>
      ))}
    </div>
  );
}

export default CompetitiveHeadToHead;
